  <h4>Configuration de la session</h4>
  
  <app-form-trainees *ngIf="sizeWindow > 768" [data]="data" (traineeActiveUpdate)="updateQuantity($event)"></app-form-trainees>
  <app-form-trainees-mobile *ngIf="sizeWindow <= 768" [data]="data" (traineeActiveUpdate)="updateQuantity($event)"></app-form-trainees-mobile>

